const controller = new AbortController();
const signal = controller.signal;

const initialState = {
	// global fetch controls
	globalFetchController: controller,
	signal: signal,
	mobileView: false,
	// loading
	isAccountsLoading: true,
	isEditing: false,
	isLoading: true,
	isLogsLoading: false,
	isMapLoading: true,
	isNodesLoading: true,
	isNodeLoading: true,
	measurementsLoading: true,
	systemLoading: true,
	areSystemsFetching: true,
	systemsForTableLoading: true,

	// data sets
	accounts: [],
	accountsWithPushNotificationsApproval: [],
	logs: null,
	logsForSystem: null,
	logsForNode: null,
	logsForSearchedText: null,
	measurements: [],
	nodes: [],
	systems: [],
	systemsForTable: [],
	systemGroups: [],
	agreements: [],
	clients: null,
	inspectionPerformers: null,
	inspections: [],
	lastCreatedInspection: null,
	serviceActions: [],
	inspectionServiceActions: [],
	auditChanges: [],
	auditChangesLoading: false,
	serviceActionAttachments: [],
	serviceActionPartImages: [],
	systemsNodesShort: [],
	systemFiles: [],
	isFilteredSystemNameUpdated: false,
	isSystemSearchBarVisible: false,
	confirmedLogSuccessfully: false,
	confirmedLogFailed: false,
	// selected
	previousNodeId: 0,
	currentNodeId: 0,
	// triggers
	notificationPopperOpen: false,
	logoutPopperOpen: false,
	gotoLogs: false,
	showChartThreshold: true,
	// timers
	error: null,
	// filters
	systemsFilter: [],
	filteredSystemId: 'all',
	dashboardFilteredSystems: [],
	dashboardFilteredSystemsNames: [],
	dashboardFilteredNodesNames: [],
	dashboardFilteredNodes: [],
	dashboardFilteredSystemNamesForGroup: [],
	// account edition
	askedAccountId: null,
	// INSTALLER
	NewNodes: [],
	FreeDevices: [],
	disableSystemSubmit: false,
	disableRefreshButton: false,
	disableCreateNodeButton: false,
	createNodeSuccess: false,
	createNodeFail: false,
	settingNewNodeNameSuccess: false,
	settingNewNodeNameFailed: false,
	createAccountSucceeded: false,
	createAccountFailed: false,
	pinAccountSucceeded: false,
	pinAccountFailed: false,
	disableRefreshCreateAccountButton: false,
	FreeSystems: [],
	disableCreateAccountButton: false,
	disabledDownloadIcons: [],
	noMeasurementsWarning: false,
	noMeasurementsWarnings: [],
	emptySystem: false,
	createAccountFailedInvalidUser: false,
	notificationSettingsUpdatedSuccessfully: false,
	notificationSettingsUpdatedFailed: false,
	updatedSystemNotificationId: null,
	isRecalculated: {},
	mapData: null,
	systemMapDataBlob: '',
	accelerateSucceeded: false,
	nodeAcceleratedUntil: null,
	//???
	disableNodeSubmit: true,
};

export default initialState;
